import React, { useEffect, useRef, useState } from 'react';

let initialized = false;
let seq = 0;

/**
 * Renders a Mermaid diagram from a code string. Falls back to showing the raw
 * source (so the evidence is never lost) if the diagram fails to parse.
 */
export default function MermaidDiagram({ chart }) {
  const containerRef = useRef(null);
  const [svg, setSvg] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const renderId = `ode-mermaid-${seq++}`;
    // Lazy-load mermaid so it ships as its own chunk (loaded only when a
    // diagram is actually rendered), keeping the main bundle lean.
    (async () => {
      const mermaid = (await import('mermaid')).default;
      if (!initialized) {
        mermaid.initialize({
          startOnLoad: false,
          securityLevel: 'strict',
          theme: 'default',
          flowchart: { htmlLabels: true, useMaxWidth: true },
        });
        initialized = true;
      }
      const { svg: out } = await mermaid.render(renderId, chart);
      if (!cancelled) {
        setSvg(out);
        setError(null);
      }
    })().catch((e) => {
      if (!cancelled) setError(e?.message || String(e));
    });
    return () => {
      cancelled = true;
    };
  }, [chart]);

  if (error) {
    return (
      <div className="ode-mermaid-fallback">
        <div className="ode-mermaid-fallback-msg">
          <i className="fas fa-triangle-exclamation" /> Diagram preview unavailable — showing source.
        </div>
        <pre>{chart}</pre>
      </div>
    );
  }

  return (
    <div
      className="ode-mermaid"
      ref={containerRef}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
